// extracted by mini-css-extract-plugin
export default {"virtualDropdown":"H2ENa1"};